import React from 'react';

import DateRangeSelect from '../date_range_select';
import SiteFilter from './site_filter';

import styles from './filters.module.css';

export const ALL_TYPES = 'all';
export const ALL_REVIEWS = 'all';
export const OUTSTANDING = 'outstanding';

const REPORT_TYPES = ['Safety Concern', 'Adherence Risk', 'Retention Risk'];

// The chip counts come from the server with the Site and Date filters applied but not the Type
// filter, so the numbers stay put as chips are switched and always say how many rows the chip
// would show. All types is the unique event count, because one event can carry more than one type.
const TypeChips = ({ typeCounts, eventCount, reportType, onChange }) => (
  <div aria-label='Filter by report type' className={styles.chips} role='group'>
    <button
      aria-pressed={reportType === ALL_TYPES}
      className={reportType === ALL_TYPES ? `${styles.chip} ${styles.chip_selected}` : styles.chip}
      onClick={() => onChange(ALL_TYPES)}
      type='button'
    >
      All types
      <span className={styles.chip_count}>{eventCount || 0}</span>
    </button>

    {REPORT_TYPES.map((type) => (
      <button
        aria-pressed={reportType === type}
        className={reportType === type ? `${styles.chip} ${styles.chip_selected}` : styles.chip}
        key={type}
        onClick={() => onChange(type)}
        type='button'
      >
        {type}
        <span className={styles.chip_count}>{typeCounts[type] || 0}</span>
      </button>
    ))}
  </div>
);

export default function Filters({
  sites,
  typeCounts,
  eventCount,
  outstandingCount,
  filters,
  onChange,
  onReset,
  isFiltered,
}) {
  const outstandingSelected = filters.reviewStatus === OUTSTANDING;

  return (
    <div className={styles.bar}>
      <div className={styles.chips}>
        <TypeChips
          eventCount={eventCount}
          onChange={(reportType) => onChange({ reportType })}
          reportType={filters.reportType}
          typeCounts={typeCounts}
        />
        <button
          aria-pressed={outstandingSelected}
          className={outstandingSelected ? `${styles.chip} ${styles.chip_selected}` : styles.chip}
          onClick={() => onChange({ reviewStatus: outstandingSelected ? ALL_REVIEWS : OUTSTANDING })}
          type='button'
        >
          Outstanding
          <span className={styles.chip_count}>{outstandingCount || 0}</span>
        </button>
      </div>

      <div className={styles.selects}>
        <SiteFilter onChange={(siteIds) => onChange({ siteIds })} selectedIds={filters.siteIds} sites={sites} />

        <DateRangeSelect
          labelId='reportable-events-date-filter-label'
          onChange={(dateRange) => onChange({ dateRange })}
          value={filters.dateRange}
        />

        {isFiltered && (
          <button className={styles.reset} onClick={onReset} type='button'>
            Clear filters
          </button>
        )}
      </div>
    </div>
  );
}
